import styles from '../../styles/Components/Shared/ArticleForm.module.css';

export default function KeyTakeaway ({ takeaways, setTakeaways }) {

    const updateTakeaways = (prevTakeaways, value, idx) => {
        let updatedTakeaways = [];
        
        for (let i = 0; i < prevTakeaways.length; i++) {
            const currentData = prevTakeaways[i]
            const takeawayData = i === idx ? { summary: value } : {}
            updatedTakeaways.push({
                ...currentData,
                ...takeawayData
            })
        }

        return updatedTakeaways
    }

    const handleChange = (e, i) => {
        const { value } = e.target;

        setTakeaways(prevTakeaway => updateTakeaways(prevTakeaway, value, i))
    }

    return takeaways?.length > 0 ? (
        <div className={styles.takeaway_section}>
            <p>Key Takeaways</p>
            {takeaways.map((takeaway, i) => (
                <div key={`takeaway-${i}`} className={styles.takeaway_row}>
                    <div>
                        <p>Takeaway {i + 1}</p>
                    </div>
                    <input
                        placeholder="Enter a short summary of this key takeaway..."
                        className={`input_basic_small`}
                        type='text'
                        name='summary'
                        value={takeaway.summary ? takeaway.summary : ''}
                        onChange={(e) => handleChange(e, i)}
                    />
                </div>
            ))}
        </div>
    ) : null
}